import { put, takeEvery } from 'redux-saga/effects'
import { createBrowserHistory } from 'history'

import { push } from 'connected-react-router'
import { appConfig } from '../../config'
import { toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'

import {
  FETCH_FEEDBKDETAILS_INIT_ACTION,
  FETCH_FEEDBKDETAILS_SUCCESS_ACTION,
  FETCH_FEEDBKDETAILS_FAIL_ACTION,
  FETCH_USERS_SEARCH_INIT_ACTION,
  FETCH_USERS_SEARCH_FAIL_ACTION,
  FETCH_USERS_SEARCH_SUCCESS_ACTION,
  FETCH_FEEDBACK_BY_ID_INIT_ACTION,
  FETCH_FEEDBACK_BY_ID_SUCCESS_ACTION,
  FETCH_FEEDBACK_BY_ID_FAIL_ACTION
} from './action'


var btoa = require('Base64').btoa
var history = createBrowserHistory()


function* fetchFeedbackList(value) {
  // console.log("saga selected page ", value.value)

  let pageno = value.value === undefined ? 1 : value.value

 



  const token = localStorage.getItem('token')

  try {
    const res = yield fetch(`${appConfig.ip}userFeedbacks?limit=10&page=` + pageno, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    if (!res.ok) {
      let errJSON = {}
      try {
        errJSON = yield res.json()
      } catch { }
      throw Object.assign(res, errJSON)
    } else {

      const resJSON = yield res.json()


      yield put({
        type: FETCH_FEEDBKDETAILS_SUCCESS_ACTION,
        payload: resJSON
      })
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_FEEDBKDETAILS_FAIL_ACTION, error: err })
    } else {
    }
  }


}

function* searchUser(value) {

  // console.log("saga search value------------->", value.value)

  let search = value.value
  const token = localStorage.getItem('token')


  try {
    const res = yield fetch(`${appConfig.ip}users?q=` + search, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    if (!res.ok) {
      let errJSON = {}
      try {
        errJSON = yield res.json()
      } catch { }
      throw Object.assign(res, errJSON)
    } else {

      const resJSON = yield res.json()
   
      yield put({
        type: FETCH_USERS_SEARCH_SUCCESS_ACTION,
        payload: resJSON
      })
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_USERS_SEARCH_FAIL_ACTION, error: err })
    } else {
    }
  }


}
function* fetchFeedbckById(value) {


  // console.log("value.value======", value.value)

  const token = localStorage.getItem('token')

  try {
    const res = yield fetch(`${appConfig.ip}userFeedbacks?userId=` + value.value.id + '&&limit=10&page=' + value.value.Spage, {
      method: 'GET',
      headers: {
        Accept: 'application/json',
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`
      }
    })
    if (!res.ok) {
      let errJSON = {}
      try {
        errJSON = yield res.json()
      } catch { }
      throw Object.assign(res, errJSON)
    } else {

      const resJSON = yield res.json()
     

      yield put({
        type: FETCH_FEEDBACK_BY_ID_SUCCESS_ACTION,
        payload: resJSON
      })
    }
  } catch (err) {
    if (err.ok === false) {
      yield put({ type: FETCH_FEEDBACK_BY_ID_FAIL_ACTION, error: err })
    } else {
    }
  }
}
export function* feedbackActionWatcher() {
  yield takeEvery(FETCH_FEEDBKDETAILS_INIT_ACTION, fetchFeedbackList)
  yield takeEvery(FETCH_USERS_SEARCH_INIT_ACTION, searchUser)
  yield takeEvery(FETCH_FEEDBACK_BY_ID_INIT_ACTION, fetchFeedbckById)

}